// global
import { push } from 'react-router-redux';
// local
// actions
import { pending, rejected, fulfilled } from '../async';
import dispatchError from '../error';
import { showSnackbar } from '../snackbar';
// api
import Patient from 'app/api/patient';

export const list = () => dispatch => {
    dispatch(pending('PATIENT_LIST'));
    Patient.list()
        .then(payload => dispatch(fulfilled('PATIENT_LIST', payload)))
        .catch(err => {
            dispatch(rejected('PATIENT_LIST', err));
            dispatchError(dispatch, err);
        });
};

export const create = data => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Patient.create(data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'PATIENT_LIST_CREATE', payload });
            dispatch(showSnackbar({ title: `O paciente ${payload.name} foi adicionado com sucesso!`, action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const update = (id, data, onSuccessCallback = null) => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Patient.update(id, data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'PATIENT_LIST_UPDATE', payload });
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
            if (!payload.latitude) {
                dispatch(showSnackbar({ title: 'Não foi possível obter as informações de latitude e longitude. Verifique o CEP cadastrado.', action: false, error: true }));
            }
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const reset = () => ({
    type: 'PATIENT_LIST_RESET',
});

export const createRow = payload => ({
    type: 'PATIENT_LIST_CREATE',
    payload,
});

export const updateRow = payload => ({
    type: 'PATIENT_LIST_UPDATE',
    payload,
});

export const search = term => ({
    type: 'PATIENT_LIST_SEARCH',
    payload: term,
});

export const filter = values => ({
    type: 'PATIENT_LIST_FILTER',
    payload: values,
});

export const openDetail = id => push(`/patients/${id}`);
